export enum TenantType {
  Dook,
  ExternalIntegrator,
  MiniAG,
}
